(function () {
    'use strict';

    /*
     OrderSummaryController
    -------------------------------------------------------------------------- */

    angular
        .module('PublicApp.ShoppingCart.orderSummary', [])
        .controller('OrderSummaryController', [
            '$scope',
            '__Form',
            '__DataStore',
            'appServices',
            '__Utils',
            '$rootScope',
            'appNotify',
            '__Auth',
            '$compile',
            OrderSummaryController
        ])
        .controller('AlertDialogController', [
            '$scope',
            AlertDialogController
        ]);

    /**
      * OrderSummaryController handle cart order
      *
      * @inject $scope
      * @inject __Form
      * @inject __DataStore
      * @inject appServices
      * @inject __Utils
      * @inject $rootScope
      * 
      * @return void
      *-------------------------------------------------------- */

    function OrderSummaryController($scope, __Form, __DataStore,
        appServices, __Utils, $rootScope, appNotify, __Auth, $compile) {

        var scope = this;
        scope = __Form.setup(scope, 'cart_order_form', 'orderData', {
            modelUpdateWatcher: false
        });

        scope.isLoggedIn = __Auth.isLoggedIn();

        $rootScope.$on('lw.auth.event.reset', function (event, authInfo) {
            scope.isLoggedIn = authInfo.authorized;
        });

        scope.couponMessage = false;
        scope.orderData.addressID = null;
        scope.orderData.addressID1 = null;
        scope.pageStatus = false;
        scope.orderData.use_as_billing = true;
        scope.orderProcessDisableStatus = true;
        scope.userIsExist = false;
        scope.shippingMethods = [];
        scope.stripePaymentMethod = 'card';

        scope.paymentMethodConfig = __globals.getSelectizeOptions({
            maxItems: 1,
            searchField: ['name'],
            plugins: ['remove_button'],
        });

        //order process wizard function
        $(document).ready(function () {
            $('#lw-smart-wizard').smartWizard({
                transitionEffect: 'fade',
            });

            // Initialize the leaveStep event
            $("#lw-smart-wizard").on("leaveStep", function (e, anchorObject, stepNumber, stepDirection) {

                var lwValidationMsg = $('#lwValidationMsg'),
                    lwValidationCustomMsg = $('#lwValidationCustomMsg'),
                    lwShippingValidationMsg = $('#lwShippingValidationMsg');

                $('html').animate({
                    scrollTop: $("#elementtoScrollToID").offset().top
                }, 500);

                if (stepDirection == 'forward' && stepNumber == 1) {

                    if (_.isUndefined(scope.orderData.shipping_method) && (scope.shippingMethods.length > 0 && !scope.orderSupportData.shipping.info)) {
                        var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('Shipping Method'));

                        appNotify.error(message);
                        return false;
                    }

                    if (_.isUndefined(scope.orderData.shipping_method) && (scope.shippingMethods.length == 0 && !scope.orderSupportData.shipping.info)) {
                        var message = lwShippingValidationMsg.attr('data-message').replace('__validationMessage__', unescape('Shipping Method'));

                        appNotify.error(message);
                        return false;
                    }

                    if (_.isEmpty(scope.orderSupportData.cartItems)) {
                        var message = lwValidationCustomMsg.attr('data-message').replace('__validationMessage__', unescape('No products in cart'));

                        appNotify.error(message);
                        return false;
                    }
                }

                if (stepDirection == 'forward' && stepNumber == 0) {

                    if (scope.orderSupportData.itemIsInvalid) {
                        var message = lwValidationCustomMsg.attr('data-message').replace('__validationMessage__', unescape('Product(s) not available in cart'));

                        appNotify.error(message);
                        return false;
                    }

                    if (scope.isLoggedIn) {
                        if (_.isEmpty(scope.orderData.fullName)) {
                            var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('full Name'));

                            appNotify.error(message);
                            return false;

                            //shipping address field is required.
                        } else if (_.isEmpty(scope.orderSupportData.shippingAddress)) {
                            var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('shipping address'));

                            appNotify.error(message);
                            return false;
                        }

                        //biiling address field is required.
                        if (scope.orderSupportData.sameAddress == false) {
                            if (_.isEmpty(scope.orderSupportData.billingAddress)) {

                                var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('billing address'));

                                appNotify.error(message);
                                return false;
                            }
                        }
                    }

                    if (!scope.isLoggedIn) {
                        //shipping address validation
                        if (_.isEmpty(scope.orderData.fullName)) {
                            var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('full Name'));

                            appNotify.error(message);
                            return false;

                        } else if (_.isEmpty(scope.orderData.email)) {
                            var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('email'));

                            appNotify.error(message);
                            return false;

                        } else if (_.isEmpty(scope.orderData.shipping_address_type) && !_.isNumber(scope.orderData.shipping_address_type)) {
                            var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('shipping type '));

                            appNotify.error(message);
                            return false;

                        } else if (_.isEmpty(scope.orderData.shipping_address_line_1)) {
                            var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('shipping address 1'));

                            appNotify.error(message);
                            return false;

                        } else if (_.isEmpty(scope.orderData.shipping_address_line_2)) {
                            var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('shipping address 2'));

                            appNotify.error(message);
                            return false;

                        } else if (_.isEmpty(scope.orderData.shipping_city)) {
                            var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('shipping city'));

                            appNotify.error(message);
                            return false;

                        } else if (_.isEmpty(scope.orderData.shipping_state)) {
                            var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('shipping state'));

                            appNotify.error(message);
                            return false;

                        } else if (_.isEmpty(scope.orderData.shipping_pin_code)) {
                            var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('shipping pin code'));

                            appNotify.error(message);
                            return false;

                        } else if (_.isEmpty(scope.orderData.shipping_country)) {
                            var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('shipping country'));

                            appNotify.error(message);
                            return false;
                        }

                        //billing address validation
                        if (scope.orderData.use_as_billing == false) {
                            if (_.isEmpty(scope.orderData.shipping_address_type) && !_.isNumber(scope.orderData.billing_address_type)) {
                                var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('billing address type '));

                                appNotify.error(message);
                                return false;

                            } else if (_.isEmpty(scope.orderData.billing_address_line_1)) {
                                var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('billing address 1'));

                                appNotify.error(message);
                                return false;
                            } else if (_.isEmpty(scope.orderData.billing_address_line_2)) {
                                var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('billing address 2'));

                                appNotify.error(message);
                                return false;
                            } else if (_.isEmpty(scope.orderData.billing_city)) {
                                var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('billing city'));

                                appNotify.error(message);
                                return false;
                            } else if (_.isEmpty(scope.orderData.billing_state)) {
                                var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('billing state'));

                                appNotify.error(message);
                                return false;
                            } else if (_.isEmpty(scope.orderData.billing_pin_code)) {
                                var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('billing pin code'));

                                appNotify.error(message);
                                return false;
                            } else if (_.isEmpty(scope.orderData.billing_country)) {
                                var message = lwValidationMsg.attr('data-message').replace('__validationMessage__', unescape('billing country'));

                                appNotify.error(message);
                                return false;
                            }
                        }
                    }
                }
                // else if(stepDirection == 'forward'  && stepNumber == 1) {
                //     __pr(scope.orderData)
                // }
                //return confirm("Do you want to leave the step "+stepNumber+"?");
            });
        });
        //order process wizard function


        /**
        * get cart order detail.
        *
        * @return void
        *------------------------------------------------------------------------ */

        scope.getCartOrderDetails = function (addressID, addressID1, couponCode, shippingCountryId, billingCountryId) {

            //  Check if country is exist
            if (!_.isUndefined(addressID)) {
                scope.addressID = addressID;
            } else {
                scope.addressID = null;
            }

            if (!_.isUndefined(addressID1)) {
                scope.addressID1 = addressID1;
            } else {
                scope.addressID1 = null;
            }

            if (!_.isUndefined(couponCode)) {
                scope.couponCode = couponCode;
            } else {
                scope.couponCode = null;
            }

            if (!_.isUndefined(shippingCountryId) && !_.isEmpty(shippingCountryId)) {
                scope.shippingCountryId = shippingCountryId;
            } else {
                scope.shippingCountryId = null;
            }

            if (!_.isUndefined(billingCountryId) && !_.isEmpty(billingCountryId)) {
                scope.billingCountryId = billingCountryId;
            } else {
                scope.billingCountryId = null;
            }

            scope.countries_select_config = __globals.getSelectizeOptions({
                valueField: 'value',
                labelField: 'text',
                searchField: ['text']
            });

            scope.shippingCount = 0;

            __DataStore.fetch({
                'apiURL': 'order.summary.details',
                'addressID': scope.addressID,
                'addressID1': scope.addressID1,
                'couponCode': scope.couponCode,
                'shippingCountryId': scope.shippingCountryId,
                'billingCountryId': scope.billingCountryId,
                'useAsBilling': scope.orderData.use_as_billing,
                'shippingMethod': !_.isUndefined(scope.orderData.shipping_method) ? scope.orderData.shipping_method : null
            }, { fresh: true }).success(
                function (responseData) {
                    appServices.processResponse(
                        responseData,
                        null,
                        function (reactionCode) {

                            var requestData = responseData.data.orderSummaryData.data;
                            //scope.paymentMethod = __globals.generateKeyValueItems(requestData.paymentMethod);

                            if (!scope.isLoggedIn) {
                                scope.addressTypes = requestData.addressSupportData.addressTypes;
                                scope.countries = requestData.addressSupportData.countries;
                            }

                            scope.shippingCount = requestData.shipping.shippingCount;

                            scope.orderSupportData = {
                                'paymentMethod': requestData.paymentMethod,
                                'cartItems': requestData.cartItems,
                                'itemsCount': requestData.itemsCount,
                                'totalQuantity': requestData.totalQuantity,
                                'itemIsInvalid': requestData.itemIsInvalid,
                                'shippingAddress': requestData.shippingAddress,
                                'sameAddress': requestData.sameAddress,
                                'billingAddress': requestData.billingAddress,
                                'shipping': requestData.shipping,
                                'formatedCartTotalPrice': requestData.total.base_price,
                                'cartTotalPrice': requestData.total.totalBasePrice,
                                'currency': requestData.total.currency,
                                'afterAddShipingTotal': requestData.shipping.totalPrice,
                                'taxses': requestData.taxses.info,
                                'formatedTotalTaxAmount': requestData.taxses.formatedTotalTaxAmount,
                                'afterAddTaxTotal': requestData.taxses.totalPrice,
                                'totalPayableAmount': requestData.totalPayableAmount,
                                'totalPayableAmountForStripe': requestData.totalPayableAmountForStripe,
                                'totalPayableAmountForPaystack': requestData.totalPayableAmountForPaystack,
                                'totalPayableAmountFormated': requestData.totalPayableAmountFormated,
                                'fullName': requestData.user.fullName,
                                'couponData': !_.isEmpty(requestData.couponData)
                                    ? requestData.couponData.couponData
                                    : null,
                                'total': requestData.total,
                                'subtotalPrice': requestData.shipping.formettedDiscountPrice,
                                'checkoutMethod': requestData.checkoutMethod,
                                'checkoutMethodInfo': requestData.checkoutMethodInfo,
                                'cartDiscount': requestData.orderDiscount,
                                'isCurrencyMismatch': requestData.isCurrencyMismatch,
                                'cartTotalBeforeDiscount': requestData.cartTotalBeforeDiscount,
                                'shipping_method': scope.orderData.shipping_method
                            };

                            var shippingAddess = !_.isEmpty(scope.addressID)
                                ? scope.addressID
                                : !_.isEmpty(scope.orderSupportData.shippingAddress) ? scope.orderSupportData.shippingAddress.id : null,

                                billingAddess = !_.isEmpty(scope.addressID1)
                                    ? scope.addressID
                                    : !_.isEmpty(scope.orderSupportData.billingAddress) ? scope.orderSupportData.billingAddress.id : null;

                            scope.shippingMethods = requestData.shipping_methods;

                            //check if shipping method is only 1 then select by default first option
                            if (scope.shippingMethods.length == 1) {
                                var shippingMethodId = scope.shippingMethods[0]['_id'];
                                if (_.isUndefined(scope.orderData.shipping_method) && scope.shippingCount == 1) {
                                    _.delay(function () {
                                        scope.getShipping(shippingMethodId);
                                    }, 500);
                                    scope.orderData.shipping_method = shippingMethodId;
                                }

                                //check if shipping method is greater than 1 then select by default first option
                            } else if (scope.shippingMethods.length > 1) {
                                var shippingMethodId = scope.shippingMethods[0]['_id'];
                                if (_.isUndefined(scope.orderData.shipping_method) && scope.shippingCount > 1) {
                                    _.delay(function () {
                                        scope.getShipping(shippingMethodId);
                                    }, 500);
                                    scope.orderData.shipping_method = shippingMethodId;
                                }
                            }

                            scope.orderData = {
                                'fullName': (scope.isLoggedIn)
                                    ? requestData.user.fullName
                                    : scope.orderData.fullName,
                                'userEmail': (scope.isLoggedIn)
                                    ? requestData.user.userEmail
                                    : scope.orderData.email,
                                'shipping_country': (!_.isEmpty(scope.shippingCountryId)) ? requestData.user.shippingCountry
                                    : '',
                                'billing_country': (!_.isEmpty(scope.billingCountryId)) ? requestData.user.billingCountry
                                    : '', //requestData.user.billingCountry,
                                'stripeKey': requestData.stripeKey,
                                'paystackPublicKey': requestData.paystackPublicKey,
                                'razorpayKey': requestData.razorpayKey,
                                'description': requestData.description,
                                'addressID': shippingAddess,
                                'businessEmail': requestData.businessEmail,
                                'checkout_method': scope.orderData.checkout_method,
                                'sameAddress': scope.orderSupportData.sameAddress,
                                'addressID1': billingAddess,
                                'totalPayableAmount': scope.orderSupportData.totalPayableAmount,
                                'totalPayableAmountForStripe': requestData.totalPayableAmountForStripe,
                                'totalPayableAmountForPaystack': requestData.totalPayableAmountForPaystack,
                                'totalPayableAmountForRazorPay': requestData.totalPayableAmountForRazorPay,
                                'couponCode': scope.couponCode,
                                'currency': requestData.total.currency,
                                'totalTaxAmount': requestData.taxses.totalTaxAmount,
                                'totalShippingAmount': requestData.shipping.totalShippingAmount,
                                // This is for non logged in user
                                'email': scope.orderData.email,
                                'use_as_billing': requestData.user.useAsBilling,
                                'shipping_address_type': scope.orderData.shipping_address_type,
                                'shipping_address_line_1': scope.orderData.shipping_address_line_1,
                                'shipping_address_line_2': scope.orderData.shipping_address_line_2,
                                'shipping_city': scope.orderData.shipping_city,
                                'shipping_state': scope.orderData.shipping_state,
                                'shipping_pin_code': scope.orderData.shipping_pin_code,
                                'billing_address_type': scope.orderData.billing_address_type,
                                'billing_address_line_1': scope.orderData.billing_address_line_1,
                                'billing_address_line_2': scope.orderData.billing_address_line_2,
                                'billing_city': scope.orderData.billing_city,
                                'billing_state': scope.orderData.billing_state,
                                'billing_pin_code': scope.orderData.billing_pin_code,
                                'discountAddedPrice': requestData.shipping.discountAddedPrice,
                                'orderDiscount': requestData.orderDiscount.discount,
                                'shipping_method': scope.orderData.shipping_method
                            };
                            //setup stripe data
                            scope.setupStripe(requestData.stripeKey);

                            scope.couponData = !_.isEmpty(requestData.couponData)
                                ? requestData.couponData
                                : null;


                            scope = __Form.updateModel(scope, scope.orderData);

                            scope.isValidItem = requestData.isValidItem;

                            if (_.isUndefined(scope.orderData.checkout_method)) {
                                scope.disabledStatus = false;
                            }

                            if (!scope.orderSupportData.shippingAddress
                                || scope.orderSupportData.shipping.isShippable === false) {
                                scope.disabledStatus = false;
                            }

                            // check if current route is order summary
                            if (requestData.orderRoute == document.location.href) {
                                scope.showCartBtn = true;
                            } else {
                                scope.showCartBtn = false;
                            }

                            // send object data to shopping cart button
                            scope.data = {
                                'routeStatus': scope.showCartBtn
                            };

                            $scope.$emit('lw.current.route.name', scope.data);

                            var $discount = $compile(__Utils.template('#cartDiscountDetailsTemplate', scope.orderSupportData.cartDiscount))(scope);
                            scope.cartDiscountDetailsHtml = $discount.html();

                            scope.pageStatus = true;

                        });
                });
        };
        scope.getCartOrderDetails();

        /**
          * Terms and conditions dialog
          *
          * @return void
          *-----------------------------------------------------------------------*/
        scope.checkValidDataForSubmit = function () {

            if (scope.isValidItem
                && scope.orderSupportData.shippingAddress
                && scope.orderSupportData.shipping.isShippable) {

                if (!_.isEmpty(scope.couponData)) {
                    if (scope.orderData.discountAddedPrice > 0) {
                        scope.disabledStatus = true;
                    } else {
                        scope.disabledStatus = false;
                    }
                } else {
                    scope.disabledStatus = true;
                }
            }
            //scope.orderData.discountAddedPrice > 0

            // Check if user is not logged in
            if (!scope.isLoggedIn) {
                if ((scope.isValidItem)
                    && (scope.orderSupportData.shipping.isShippable)) {

                    if (!_.isEmpty(scope.couponData)) {
                        if (scope.orderData.discountAddedPrice > 0) {
                            scope.orderProcessDisableStatus = false;
                        } else {
                            scope.orderProcessDisableStatus = true;
                        }
                    } else {
                        scope.orderProcessDisableStatus = false;
                    }
                }
            }
        };

        /*
         when user is not logged in then call this function
        -------------------------------------------------------------------------- */
        scope.changeAddressType = function (value) {

            if (value) {
                scope.orderData.billing_country = null;
                scope.getCartOrderDetails(null, null, scope.couponCode, scope.orderData.shipping_country, scope.orderData.billing_country);
            } else {
                scope.getCartOrderDetails(null, null, scope.couponCode, scope.orderData.shipping_country, scope.orderData.billing_country);
            }
        }

        /*
         when user is not logged in then call this function
        -------------------------------------------------------------------------- */
        scope.getShipping = function () {

            scope.getCartOrderDetails(scope.orderData.addressID, scope.orderData.addressID1, scope.couponCode, scope.shippingCountryId, scope.billingCountryId);
        }

        /**
          * apply coupon submit method
          *
          * @param string couponCode
          * @param number orderTotalPrice
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.orderData.coupon = '';
        scope.newCouponCode = '';

        scope.applyCoupon = function (couponCode) {

            __DataStore.post({
                'apiURL': 'order.coupon.apply'
            }, scope).success(function (responseData) {

                appServices.processResponse(responseData, function (reactionCode) {

                    scope.couponData = responseData.data.couponData;
                    scope.couponStatus = reactionCode;
                    scope.invalidCouponCode = responseData.data.couponCode;
                    scope.couponMessage = true;
                    scope.orderData.subtotalPrice = responseData.data.totalPrice;

                    var shippingAddress = !_.isEmpty(scope.orderData.addressID)
                        ? scope.orderData.addressID
                        : !_.isEmpty(scope.orderSupportData.shippingAddress) ? scope.orderSupportData.shippingAddress.id : null,

                        billingAddress = !_.isEmpty(scope.orderData.addressID1)
                            ? scope.orderData.addressID1
                            : !_.isEmpty(scope.orderSupportData.billingAddress) ? scope.orderSupportData.billingAddress.id : null;

                    scope.getCartOrderDetails(shippingAddress, billingAddress, scope.couponData.couponCode, scope.shippingCountryId, scope.billingCountryId);

                    scope.validCouponAmtMessage = __ngSupport.getText(
                        __globals.getJSString('order_coupon_amount_text'), {
                        '__amount__': scope.couponData
                    });

                    scope.orderData.code = "";
                    scope.checkValidDataForSubmit();

                    var $discount = $compile(__Utils.template('#couponDetailsTemplate', scope.couponData))(scope);
                    scope.couponDetailsHtml = $discount.html();
                });

            });

        };

        scope.disabledStatus = true;

        /**
          * Remove coupon 
          *
          * @return void
          *---------------------------------------------------------------- */

        scope.removeCoupon = function () {

            //scope.orderData.addressID  = scope.orderSupportData.shippingAddress.id;
            //scope.orderData.addressID1 = scope.orderSupportData.billingAddress.id;

            scope.getCartOrderDetails(scope.orderData.addressID, scope.orderData.addressID1, null, scope.shippingCountryId, scope.billingCountryId);
            scope.couponMessage = false;
            scope.couponStatus = null;

            // Check if discount amount exist 
            // if exist then remove discount amount
            if (!_.isEmpty(scope.couponData.discountFormate)) {
                scope.couponData.discountFormate = '';
            }

            scope.checkValidDataForSubmit

        }



	    /**
	    * remove invalid item in the cart
	    *
	    * @param {Number} itemID - cart item row id.
	    * @return void
	    * 
	    *------------------------------------------------------------------------ */

        scope.removeAllInvlidCartItem = function (status) {

            // get data using angular $http.get() method
            __DataStore.post('cart.remove.invalid.item', scope)
                .success(function (responseData) {
                    appServices.processResponse(responseData, null,
                        function (reactionCode) {

                            scope.data = {
                                'cart_string': responseData.data.cartItems,
                                'status': true
                            }

                            $scope.$emit('lw.update.cart.string', scope.data);
                            $rootScope.$emit('remove.cart.row', { 'status': true });
                            scope.getCartOrderDetails(scope.orderData.addressID, scope.orderData.addressID1, scope.couponCode, scope.shippingCountryId, scope.billingCountryId);
                        }
                    );

                });

        };

	    /**
	    * call function if any items is invalid on process time 
	    *
	    * @param object param 1 type 
	    *
	    * @return void
	    *---------------------------------------------------------------- */

        scope.updatOrderSummary = function (responseData) {

            var requestData = responseData.orderSummaryData;

            scope.shippingCount = requestData.shipping.shippingCount;

            scope.orderSupportData = {
                'paymentMethod': requestData.paymentMethod,
                'cartItems': requestData.cartItems,
                'itemsCount': requestData.itemsCount,
                'totalQuantity': requestData.totalQuantity,
                'itemIsInvalid': requestData.itemIsInvalid,
                'shippingAddress': requestData.shippingAddress,
                'sameAddress': requestData.sameAddress,
                'businessEmail': requestData.businessEmail,
                'billingAddress': requestData.billingAddress,
                'shipping': requestData.shipping.info,
                'formatedCartTotalPrice': requestData.total.base_price,
                'formatedTotalTaxAmount': requestData.taxses.formatedTotalTaxAmount,
                'cartTotalPrice': requestData.total.totalBasePrice,
                'currency': requestData.total.currency,
                'afterAddShipingTotal': requestData.shipping.totalPrice,
                'taxses': requestData.taxses.info,
                'afterAddTaxTotal': requestData.taxses.totalPrice,
                'totalPayableAmount': requestData.totalPayableAmount,
                'totalPayableAmountFormated': requestData.totalPayableAmountFormated,
                'fullName': requestData.user.fullName,
                'total': requestData.total,
                'couponData': !_.isEmpty(requestData.couponData)
                    ? requestData.couponData.couponData
                    : null,
                'subtotalPrice': requestData.shipping.formettedDiscountPrice,
                'checkoutMethod': requestData.checkoutMethod,
                'checkoutMethodInfo': requestData.checkoutMethodInfo,
                'shipping_method': scope.orderData.shipping_method
            };

            var shippingAddress = !_.isEmpty(scope.orderData.addressID)
                ? scope.orderData.addressID
                : !_.isEmpty(scope.orderSupportData.shippingAddress) ? scope.orderSupportData.shippingAddress.id : null,

                billingAddress = !_.isEmpty(scope.orderData.addressID1)
                    ? scope.orderData.addressID1
                    : !_.isEmpty(scope.orderSupportData.billingAddress) ? scope.orderSupportData.billingAddress.id : null;

            scope.orderData = {
                'fullName': (scope.isLoggedIn)
                    ? requestData.user.fullName
                    : scope.orderData.fullName,
                'userEmail': (scope.isLoggedIn)
                    ? requestData.user.userEmail
                    : scope.orderData.email,
                'description': requestData.description,
                'razorpayKey': requestData.razorpayKey,
                'stripeKey': requestData.stripeKey,
                'paystackPublicKey': requestData.paystackPublicKey,
                'addressID': shippingAddress,
                'checkout_method': scope.orderData.checkout_method,
                'sameAddress': scope.orderSupportData.sameAddress,
                'businessEmail': requestData.businessEmail,
                'addressID1': billingAddress,
                'totalPayableAmount': scope.orderSupportData.totalPayableAmount,
                'totalPayableAmountForStripe': requestData.totalPayableAmountForStripe,
                'totalPayableAmountForPaystack': requestData.totalPayableAmountForPaystack,
                'totalPayableAmountForRazorPay': requestData.totalPayableAmountForRazorPay,
                'couponCode': scope.couponCode,
                'currency': requestData.total.currency,
                'totalTaxAmount': requestData.taxses.totalTaxAmount,
                'totalShippingAmount': requestData.shipping.totalShippingAmount,
                // This is for non logged in user
                'email': scope.orderData.email,
                'use_as_billing': requestData.user.useAsBilling,
                'shipping_address_type': scope.orderData.shipping_address_type,
                'shipping_address_line_1': scope.orderData.shipping_address_line_1,
                'shipping_address_line_2': scope.orderData.shipping_address_line_2,
                'shipping_city': scope.orderData.shipping_city,
                'shipping_state': scope.orderData.shipping_state,
                'shipping_pin_code': scope.orderData.shipping_pin_code,
                'billing_address_type': scope.orderData.billing_address_type,
                'billing_address_line_1': scope.orderData.billing_address_line_1,
                'billing_address_line_2': scope.orderData.billing_address_line_2,
                'billing_city': scope.orderData.billing_city,
                'billing_state': scope.orderData.billing_state,
                'billing_pin_code': scope.orderData.billing_pin_code,
                'discountAddedPrice': requestData.shipping.discountAddedPrice,
                'orderDiscount': requestData.orderDiscount.discount,
                'shipping_method': scope.orderData.shipping_method
            };

            scope = __Form.updateModel(scope, scope.orderData);

            if (requestData.isValidItem == false) {
                scope.isValidItem = false;
                scope.disabledStatus = false;
                scope.orderProcessDisableStatus = true;
            } else {
                scope.disabledStatus = true;
                scope.orderProcessDisableStatus = false;
            }

            // check if current route is order summary
            if (requestData.orderRoute == document.location.href) {
                scope.showCartBtn = true;
            } else {
                scope.showCartBtn = false;
            }

            // send object data to shopping cart button
            scope.data = {
                'routeStatus': scope.showCartBtn
            };

            $scope.$emit('lw.current.route.name', scope.data);

            scope.pageStatus = true;

        };

        /**
          * order submit process
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.orderData.totalDiscountAmount = 0;

        scope.handleOrderValidationErrors = function (reaction, responseData) {

            // call function when any invalid data to display to user
            if (reaction == 3) {
                //scope.updatOrderSummary(responseData.data);

                appServices.showDialog(responseData,
                    {
                        templateUrl: __globals.getTemplateURL('order.user.alert-dialog')
                    },
                    function (promiseObj) {

                        if (_.has(promiseObj, 'value')
                            && promiseObj.value.is_submit_order === true) {

                            //scope.updatOrderSummary(responseData.data);
                            var shippingAddress = !_.isEmpty(scope.orderData.addressID)
                                ? scope.orderData.addressID
                                : !_.isEmpty(scope.orderSupportData.shippingAddress) ? scope.orderSupportData.shippingAddress.id : null,

                                billingAddress = !_.isEmpty(scope.orderData.addressID1)
                                    ? scope.orderData.addressID1
                                    : !_.isEmpty(scope.orderSupportData.billingAddress) ? scope.orderSupportData.billingAddress.id : null;
                            var couponCode = _.isEmpty(scope.couponData) ? null : scope.couponData.couponCode
                            scope.getCartOrderDetails(shippingAddress, billingAddress, couponCode, scope.shippingCountryId, scope.billingCountryId);

                        } else {

                            __globals.redirectBrowser(__Utils.apiURL('cart.view'));

                        }



                    });
            }

        };

        scope.orderSubmit = function () {
            __globals.showProcessingDialog();

            if (_.has(scope, 'couponData')
                && !_.isUndefined(scope.couponData)
                && !_.isEmpty(scope.couponData)) {
                scope.orderData.totalDiscountAmount = scope.couponData.discount;
            }

            if (scope.cart_order_form.$valid == false
                && scope.orderData.checkout_method !== 6) {
                __globals.hideProcessingDialog();
            } else if (scope.cart_order_form.$valid == false
                && scope.orderData.checkout_method === 6) {
                __globals.hideProcessingDialog();
                appNotify.error(__globals.getJSString('order_error_messages'));
            }

            if (scope.orderData.checkout_method == 11) {

                if (scope.cart_order_form.$valid) {
                    var options = {
                        "key": scope.orderData.razorpayKey,
                        "amount": scope.orderData.totalPayableAmountForRazorPay.toFixed(2), // 2000 paise = INR 20
                        "currency": scope.orderData.currency,
                        "name": scope.orderData.fullName,
                        //"description": "Purchase Description",
                        "handler": function (response) {

                            if (!_.isEmpty(response.razorpay_payment_id)) {

                                // Token is ready lets go and charge the card
                                __DataStore.post('order.razorpay.checkout', _.assign({
                                    'razorpay_payment_id': response.razorpay_payment_id,
                                    'checkout_method': 11,
                                }, scope.orderData), scope)
                                    .success(function (responseData) {

                                        var dataRecieved = responseData.data;


                                        appServices.processResponse(responseData, function (reaction) {
                                            // check reaction code not equal to 1
                                            if (responseData.reaction !== 1) {

                                                scope.handleOrderValidationErrors(reaction, responseData);

                                                if (reaction == 2 && _.has(responseData.data, 'orderSummaryData')) {
                                                    scope.updatOrderSummary(responseData.data);
                                                } else if (reaction == 9) {
                                                    $rootScope.$broadcast('lw-open-login-dialog', { 'data': '' });
                                                }
                                            }

                                        }, function () {
                                            // if found ok redirect customer to thank you page
                                            __globals.redirectBrowser(__Utils.apiURL('order.thank_you_razorpay', {
                                                'orderToken': dataRecieved.razorpayChargeRequest.orderPaymentToken
                                            }));

                                        });

                                    });
                            }
                        },
                        "prefill": {
                            "name": scope.orderData.fullName,
                            "email": scope.orderData.userEmail
                        },
                        //"notes": {
                        //"address": "fweffwfwf"
                        //},
                        "theme": {
                            "color": "#050505"
                        },
                        "modal": {
                            "ondismiss": function (e) { }
                        }
                    };
                    __globals.hideProcessingDialog();
                    var rzp1 = new Razorpay(options);
                    rzp1.open();
                    // e.preventDefault();
                    // document.getElementById('rzp-button1').onclick = function(e){
                    //     rzp1.open();
                    //     e.preventDefault();
                    // }
                }

            } else if (scope.orderData.checkout_method == 20) {

                if (scope.cart_order_form.$valid) {
                    var handler = PaystackPop.setup({
                        key: scope.orderData.paystackPublicKey,
                        email: scope.orderData.userEmail,
                        amount: scope.orderData.totalPayableAmountForPaystack,
                        currency: scope.orderData.currency,
                        callback: function (response) {
                            var paystackRefrenceId = response.reference;
                            if (!_.isEmpty(paystackRefrenceId)) {

                                // Token is ready lets go and charge the card
                                __DataStore.post('order.paystack.checkout', _.assign({
                                    'paystack_refrence_id': paystackRefrenceId,
                                    'checkout_method': 20,
                                }, scope.orderData), scope)
                                    .success(function (responseData) {

                                        var dataRecieved = responseData.data;

                                        appServices.processResponse(responseData, function (reaction) {
                                            // check reaction code not equal to 1
                                            if (responseData.reaction !== 1) {

                                                scope.handleOrderValidationErrors(reaction, responseData);

                                                if (reaction == 2 && _.has(responseData.data, 'orderSummaryData')) {
                                                    scope.updatOrderSummary(responseData.data);
                                                } else if (reaction == 9) {
                                                    $rootScope.$broadcast('lw-open-login-dialog', { 'data': '' });
                                                }
                                            }
                                        }, function () {
                                            // if found ok redirect customer to thank you page
                                            __globals.redirectBrowser(__Utils.apiURL('order.thank_you_paystack', {
                                                'orderToken': dataRecieved.orderPaymentToken
                                            }));

                                        });

                                    });
                            }
                        },
                        onClose: function () {
                        }
                    });
                    handler.openIframe();
                    __globals.hideProcessingDialog();
                }
            } else { // NOT Stripe
                if (scope.orderData.checkout_method == 14) {
                    scope.orderData.card_number = String(scope.orderData.card_number);
                }

                // stripe incomplete information error
                if (scope.orderData.checkout_method == 6) {
                    if (!scope.isStripePaymentFormComplete) {
                        __globals.hideProcessingDialog();
                        appNotify.error('Incomplete Payment/Card Information');
                        $("#lwStripeCardErrors").show();
                        scope.displayStripeError.textContent = 'Incomplete Payment/Card Information';
                        return false;
                    }
                }

                __Form.process('order.process', scope)
                    .success(function (responseData) {

                        appServices.processResponse(responseData, {
                            then: function (reaction) {

                                if (reaction == 3 && !_.has(responseData.data, 'validation')) {

                                    scope.handleOrderValidationErrors(reaction, responseData);
                                }

                                if (reaction == 2 && _.has(responseData.data, 'orderSummaryData')) {
                                    scope.updatOrderSummary(responseData.data);
                                } else if (reaction == 9) {
                                    $rootScope.$broadcast('lw-open-login-dialog', { 'data': '' });
                                }
                            }

                        }, function () {
                            //paypal checkout
                            if (responseData.reaction == 1 && (responseData.data.ckMethod == 1)) {
                                __globals.redirectBrowser(__Utils.apiURL('order.paypal.checkout', {
                                    'orderUID': responseData.data.orderID
                                }));

                                //iyzico checkout
                            } else if (responseData.reaction == 1 && (responseData.data.ckMethod == 14) || (responseData.data.ckMethod == 15)) {

                                $('body').html(responseData.data.htmlContent);

                                // document.downloadForm.submit()
                                // _.delay(function () {
                                //     $('.lw-loader-container form').submit();
                                // }, 300);

                                //paytm checkout
                            } else if (responseData.reaction == 1 && (responseData.data.ckMethod == 16) || (responseData.data.ckMethod == 17)) {

                                __globals.redirectBrowser(__Utils.apiURL('order.paytm.checkout', {
                                    'orderUID': responseData.data.orderID
                                }));

                                //instamojo checkout
                            } else if (responseData.reaction == 1 && (responseData.data.ckMethod == 18) || (responseData.data.ckMethod == 19)) {

                                __globals.redirectBrowser(__Utils.apiURL('order.instamojo.checkout', {
                                    'orderUID': responseData.data.orderID
                                }));

                                //stripe checkout
                            } else if (responseData.reaction == 1 && (responseData.data.ckMethod == 6) || (responseData.data.ckMethod == 8)) {

                                __globals.showProcessingDialog();
                                //create stripe payment method
                                scope.stripeCheckout.createPaymentMethod(scope.stripePaymentMethod, scope.stripeCard).then(function (result) {
                                    //check if any error exist
                                    if (result.error) {
                                        appNotify.error(result.error.message);
                                        scope.displayStripeError.textContent = result.error.message;
                                        $("#lwStripeCardErrors").show();
                                        __globals.hideProcessingDialog();
                                        return false;
                                    } else {
                                        var paymentMethodId = result.paymentMethod.id,
                                            orderUID = responseData.data.orderID;
                                        // Token is ready lets go and charge the card
                                        __DataStore.post('order.stripe.write.create_payment_intent', _.assign({
                                            'paymentMethodId': paymentMethodId,
                                            'orderUID': orderUID,
                                        }, scope.orderData), scope).success(function (responseData) {
                                            var paymentIntentData = responseData.data;
                                            //check if any error from server side.
                                            if (responseData.reaction != 1) {
                                                scope.displayStripeError.textContent = responseData.data.message;
                                                $("#lwStripeCardErrors").show();
                                                __globals.hideProcessingDialog();
                                            }
                                            appServices.processResponse(responseData, function (reactionCode) {
                                                //check reaction code is 1
                                                if (reactionCode == 1) {
                                                    __globals.hideProcessingDialog();

                                                    if (paymentIntentData.data.requiresAction) {
                                                        // Request authentication
                                                        scope.handleStripeAction(paymentIntentData.data.clientSecret, orderUID);
                                                    } else {
                                                        //store stripe payment data
                                                        scope.stripePaymentComplete(paymentIntentData.data.clientSecret, orderUID);
                                                    }
                                                }
                                            });
                                        });
                                    }
                                })
                            } else if (responseData.reaction == 1) {

                                if (scope.isLoggedIn) {
                                    __globals.redirectBrowser(__Utils.apiURL('my_order.details', {
                                        'orderUID': responseData.data.orderID
                                    }));
                                } else if (!scope.isLoggedIn) {
                                    __globals.redirectBrowser(__Utils.apiURL('order.guest_order_success'));
                                }

                            }
                        });
                    });

            }
        };

        //create inline-stripe checkout payment gateway
        //Reference link -https://stripe.com/docs/payments/accept-a-payment-synchronously
        //Reference link -https://stripe.com/docs/js/element/events/on_escape
        scope.setupStripe = function (stripePublishKey) {
            scope.isStripePaymentFormComplete = false;

            //check stripe key empty or undefined
            if (!_.isEmpty(stripePublishKey) && !_.isUndefined(stripePublishKey)) {
                scope.stripeCheckout = Stripe(stripePublishKey);
                // Set up Stripe.js and Elements to use in checkout form
                var elements = scope.stripeCheckout.elements(),
                    style = {
                        base: {
                            color: "#32325d",
                            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                            fontSmoothing: "antialiased",
                            fontSize: "16px",
                            "::placeholder": {
                                color: "#aab7c4"
                            }
                        },
                        invalid: {
                            color: "#fa755a",
                            iconColor: "#fa755a"
                        }
                    };

                scope.stripeCard = elements.create(scope.stripePaymentMethod, { style: style });
                scope.stripeCard.mount("#lwStripeCardInfo");
                scope.displayStripeError = document.getElementById('lwStripeCardErrors');

                $("#lwStripeCardErrors").hide();
                //on change inline stripe validation type errors
                scope.stripeCard.on('change', function (changeEvent) {
                    scope.isStripePaymentFormComplete = changeEvent.complete;
                    //check error exist
                    if (changeEvent && !_.isUndefined(changeEvent.error)) {
                        scope.displayStripeError.textContent = changeEvent.error.message;
                        $("#lwStripeCardErrors").show();
                    } else {
                        $("#lwStripeCardErrors").hide();
                        scope.displayStripeError.textContent = '';
                    }
                });
            }
        };

        // //handle stripe requires action
        scope.handleStripeAction = function (clientSecret, orderUID) {
            //handle stripe 3d secure authentication modal
            scope.stripeCheckout.handleCardAction(clientSecret).then(function (result) {
                //check if any error
                if (result.error) {
                    appNotify.error(result.error.message);
                    $("#lwStripeCardErrors").show();
                    scope.displayStripeError.textContent = result.error.message;
                    return false;
                } else if (result.paymentIntent.status === "requires_confirmation") {
                    __globals.showProcessingDialog();

                    // Token is ready lets go and charge the card
                    __DataStore.post('order.stripe.write.retrieve_payment_intent', _.assign({
                        'paymentIntentId': result.paymentIntent.id
                    }, scope.orderData), scope).success(function (responseData) {
                        var retrievePaymentIntent = responseData.data;
                        appServices.processResponse(responseData, function (reactionCode) {
                            //check reaction code is 1
                            if (reactionCode == 1) {
                                //store stripe payment data
                                scope.stripePaymentComplete(clientSecret, orderUID);
                            }
                        });
                    });
                }
            });
        };

        //store stripe payment data
        scope.stripePaymentComplete = function (clientSecret, orderUID) {
            //retrieve stripe payment data
            this.stripeCheckout.retrievePaymentIntent(clientSecret).then(function (result) {
                //check if any error
                if (result.error) {
                    appNotify.error(result.error.message);
                    $("#lwStripeCardErrors").show();
                    scope.displayStripeError.textContent = result.error.message;
                    return false;

                    //check is success retrieve payment intent
                } else {
                    // Token is ready lets go and charge the card
                    __DataStore.post('order.stripe.write.store_payment', _.assign({
                        'orderUID': orderUID,
                        'paymentIntentData': result.paymentIntent
                    }), scope).success(function (responseData) {
                        var retrievePaymentIntent = responseData.data;
                        __globals.hideProcessingDialog();

                        appServices.processResponse(responseData, function (reactionCode) {
                            //check reaction code is 1
                            if (reactionCode == 1) {
                                //clear card elements after create payment method
                                scope.stripeCard.clear();

                                // if found ok redirect customer to thank you page
                                __globals.redirectBrowser(__Utils.apiURL('order.thank_you_stripe', {
                                    'orderUID': orderUID
                                }));
                            }
                        });
                    });
                }
            });
        };

        /**
          * shipping & billing address not same
          *
          * @param sameAddress.
          * @param shippingAddress
          *
          * @return void
          *
          *------------------------------------------------------------------------ */
        scope.sameAsAddress = function (sameAddress, shippingAddress) {

            if (sameAddress == false) {

                scope.orderSupportData.billingAddress = '';
                scope.orderData.addressID1 = '';

            } else {

                scope.getCartOrderDetails(
                    scope.orderData.addressID,
                    scope.orderData.addressID,
                    scope.couponCode);
            }

            scope.orderData.sameAddress = sameAddress;
        };

        /**
          * if user click on change address then open dialog
          *
          * @param {boolean} sameAddress
          * @param {string}  addressType
          * @param {string}  countryCode
          *
          * @return void
          *---------------------------------------------------------------- */

        scope.openAddressListDialog = function (sameAddress, addressType) {
            appServices.showDialog(scope,
                {
                    templateUrl: __globals.getTemplateURL('address.list-dialog')
                },
                function (promiseObj) {

                    if (!_.isUndefined(promiseObj.value) && (promiseObj.value != '$closeButton')) {

                        var selectedaddress = promiseObj.value.selectedAddress;

                        if (sameAddress == false && addressType == 'billing') {

                            scope.orderSupportData.billingAddress = selectedaddress;
                            scope.orderData.addressID1 = selectedaddress.id;
                            scope.orderSupportData.sameAddress = false;
                            scope.getCartOrderDetails(scope.orderData.addressID, scope.orderData.addressID1, scope.couponCode);

                        } else if (sameAddress == true && addressType == 'billing') {

                            scope.orderSupportData.shippingAddress = selectedaddress;
                            scope.orderSupportData.billingAddress = selectedaddress;
                            scope.orderData.addressID = selectedaddress.id;
                            scope.orderData.addressID1 = selectedaddress.id;


                        } else if (sameAddress == true && addressType == 'shipping') {

                            scope.orderSupportData.shippingAddress = selectedaddress;
                            scope.orderSupportData.billingAddress = selectedaddress;
                            scope.orderData.addressID = selectedaddress.id;
                            scope.orderData.addressID1 = selectedaddress.id;
                            scope.getCartOrderDetails(scope.orderData.addressID, scope.orderData.addressID1, scope.couponCode);

                            if (scope.orderSupportData.shipping.isShippable) {
                                scope.disabledStatus = true;
                            }

                        } else if (sameAddress == false && addressType == 'shipping') {

                            scope.orderSupportData.shippingAddress = selectedaddress;
                            scope.orderData.addressID = selectedaddress.id;

                            scope.orderData.addressID1 = _.isEmpty(scope.orderData.addressID1) ? scope.orderSupportData.billingAddress.id : scope.orderData.addressID1;

                            if (scope.orderSupportData.shipping.isShippable) {
                                scope.disabledStatus = true;
                            }


                            if (!_.isEmpty(scope.orderData.addressID) && scope.orderData.addressID === scope.orderData.addressID1) {
                                scope.orderData.addressID1 = selectedaddress.id;
                                scope.orderSupportData.sameAddress = true;
                            }

                            scope.getCartOrderDetails(
                                scope.orderData.addressID,
                                scope.orderData.addressID1,
                                scope.couponCode);

                        }
                    }

                    scope.checkValidDataForSubmit();
                });

        };


        /**
	    * remove cart item action
	    *
	    * @param {Number} itemID - cart item row id.
	    * @return void
	    * 
	    *------------------------------------------------------------------------ */

        scope.removeCartItem = function (itemID) {

            // get data using angular $http.get() method
            __DataStore.post({
                'apiURL': 'cart.remove.item',
                'itemID': itemID
            }, scope).success(function (responseData) {

                appServices.processResponse(responseData, null,
                    function (reactionCode) {

                        scope.data = {
                            'cart_string': responseData.data.cartItems,
                            'status': true
                        }

                        $scope.$emit('lw.update.cart.string', scope.data);

                        $('#rowid_' + itemID).fadeOut('slow', function () {
                            $(this).remove();
                        });
                        scope.getCartOrderDetails();

                    }
                );

            });

        };

	    /**
	    * remove cart item of product out of stock and invalid
	    *
	    * @param {Number} itemID - cart item row id.
	    * @return void
	    * 
	    *------------------------------------------------------------------------ */

        scope.removeAllCartItem = function (status) {

            // get data using angular $http.get() method
            __DataStore.post('cart.remove.invalid.item', scope)
                .success(function (responseData) {
                    appServices.processResponse(responseData, null,
                        function (reactionCode) {

                            scope.data = {
                                'cart_string': responseData.data.cartItems,
                                'status': true
                            }

                            $scope.$emit('lw.update.cart.string', scope.data);
                            scope.getCartOrderDetails();
                        }
                    );

                });

        };

        /**
        * Check user email 
        *
        * @return void
        * 
        *------------------------------------------------------------------------ */
        scope.checkUserEmail = function () {

            if (!_.isEmpty(scope.orderData.email)) {
                __DataStore.fetch({
                    'apiURL': 'order.check.user_email',
                    'email': scope.orderData.email,
                    'couponId': (!_.isEmpty(scope.couponData))
                        ? scope.couponData.couponID
                        : null
                }).success(function (responseData) {
                    var requestData = responseData.data;
                    scope.invalidCouponMessage = requestData.message;

                    if (_.isNull(requestData.userId)) {
                        scope.userIsExist = false;
                    } else {
                        scope.userIsExist = true;
                    }

                    scope.orderData.guestLoggedInUserId = requestData.userId;
                    appServices.processResponse(responseData, {
                        then: function (reaction) {
                            if (reaction == 2) {
                                appServices.showDialog(responseData,
                                    {
                                        templateUrl: __globals.getTemplateURL('order.user.alert-dialog')
                                    },
                                    function (promiseObj) {
                                        scope.removeCoupon();
                                    });
                            }
                        }
                    }, function (reaction) {

                    });
                });
            }
        };

        // If user is not logged in then open logged in dialog
        scope.openLoginDialog = function () {
            var responseData = {
                'guestOrder': false
            };

            $rootScope.$broadcast('lw-open-login-dialog', { 'data': responseData });
        };

        /**
        * Refresh product 
        *
        * @return void
        * 
        *------------------------------------------------------------------------ */
        scope.refreshProduct = function (item) {
            __DataStore.post('cart.refresh.product', item)
                .success(function (responseData) {
                    appServices.processResponse(responseData, null, function () {
                        scope.getCartOrderDetails(scope.orderData.addressID, scope.orderData.addressID1, scope.couponCode, scope.shippingCountryId, scope.billingCountryId);
                    });
                });
        };

        /**
        * Open Discount details
        *
        * @return void
        *------------------------------------------------------------------------ */
        scope.openDiscountDetails = function () {
            $('#lw-discount-detail-table').slideToggle();
        };

    };


    function AlertDialogController($scope) {

        var scope = this;
        scope.pageStatus = false;

        if ($scope.ngDialogData) {
            scope.message = $scope.ngDialogData.data.message;
            scope.pageStatus = true;
        }

        /**
          * Response for submit order
          *
          * @return void
          *-----------------------------------------------------------------------*/

        scope.yesSubmitIt = function () {
            $scope.closeThisDialog({ 'is_submit_order': true })
        };


        /**
        * Close this dialog
        *
        * @return void
        *-----------------------------------------------------------------------*/

        scope.closeDialog = function () {
            $scope.closeThisDialog({ 'is_submit_order': false })
        };

    };

})();